import { BehaviorSubject, Observable } from "rxjs";
import { CalendarValueType, CalendarMultipleValueType, ICalendarItem } from "./types";
import { share } from "rxjs/operators";
import lodash from 'lodash';

export class CalendarContext {
  private _groupMask: ((name: string) => string) | null;
  public get groupMask() {
    return this._groupMask;
  }
  private _multiple: boolean;
  public get multiple() {
    return this._multiple;
  }
  private _groupSize: number;
  public get groupSize() {
    return this._groupSize;
  }
  private _fillBlanks: ((fillId: string) => string) | null;
  public get fillBlanks() {
    return this._fillBlanks;
  }
  constructor(multiple: boolean, groupSize: number, fillBlank?: (fillId: string) => string, groupMask?: (name: string) => string) {
    this._multiple = multiple;
    this._groupSize = groupSize;
    this._groupMask = groupMask || null;
    this._fillBlanks = fillBlank || null;
    this._value = new BehaviorSubject<CalendarValueType | CalendarMultipleValueType>(null);
    this._items = new BehaviorSubject<ICalendarItem[] | null>(null);
    this._openState = new BehaviorSubject<boolean>(false);
  }

  protected _value: BehaviorSubject<CalendarValueType | CalendarMultipleValueType>;
  protected _items: BehaviorSubject<ICalendarItem[] | null>;
  protected _openState: BehaviorSubject<boolean>;

  public get currentValue(): CalendarValueType | CalendarMultipleValueType {
    return this._value.value;
  }
  public get value(): Observable<CalendarValueType | CalendarMultipleValueType> {
    return this._value.pipe(share());
  }
  public setValue(val: CalendarValueType | CalendarMultipleValueType) {
    this._value.next(val);
  }

  public get currentItems(): ICalendarItem[] | null {
    return this._items.value;
  }
  public get items(): Observable<ICalendarItem[] | null> {
    return this._items.pipe(share());
  }
  public setItems(val: ICalendarItem[] | null) {
    this._items.next(lodash.orderBy(val, x => x.id));
  }

  public get currentOpenState(): boolean {
    return this._openState.value;
  }
  public get openState(): Observable<boolean> {
    return this._openState.pipe(share());
  }
  public setOpenState(val: boolean) {
    this._openState.next(val);
  }
}